import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-appnotificationmanagement',
  templateUrl: './appnotificationmanagement.component.html',
  styleUrls: ['./appnotificationmanagement.component.css']
})
export class AppnotificationmanagementComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
